<template>
  <footer class="footer ws">
    <div class="wrap">
      <div class="footer__grid">
        <div class="footer__brand">
          <img class="footer__logo" src="/website/img/logo-white.png" alt="Taoify">
          <p class="footer__desc">{{ $t('给想把中国货卖到全世界的人，一个能真正跑通生意的地方。') }}</p>
          <div class="footer__social">
            <!-- 原来 5 个社交图标全是 href="#" 的死链，指向的账号并不存在。
                 先只放两个确定能用的渠道：在线客服和邮件（想加社媒，等真开了号再补） -->
            <button type="button" :aria-label="$t('在线客服')" :title="$t('在线客服')" @click="askAi">
              <svg class="ico ico--sm ico--solid"><use href="#i-chat"/></svg>
            </button>
            <a href="mailto:liutaotao@taocarts.com" :aria-label="$t('发邮件')" :title="$t('发邮件')">
              <svg class="ico ico--sm ico--solid"><use href="#i-mail"/></svg>
            </a>
          </div>
        </div>

        <div>
          <h5>{{ $t('产品') }}</h5>
          <ul>
            <li><router-link to="/feature">{{ $t('全部功能') }}</router-link></li>
            <li><router-link to="/ai-staff">{{ $t('AI 员工') }}</router-link></li>
            <li><router-link to="/logistics">{{ $t('跨境物流') }}</router-link></li>
            <li><router-link to="/payment">{{ $t('收款与结算') }}</router-link></li>
            <li><router-link to="/pricing">{{ $t('价格') }}</router-link></li>
            <li><router-link to="/template-index">{{ $t('模板市场') }}</router-link></li>
          </ul>
        </div>

        <div>
          <h5>{{ $t('卖家') }}</h5>
          <ul>
            <li><router-link to="/for-china-sellers">{{ $t('我在中国 · 把货卖出去') }}</router-link></li>
            <li><router-link to="/for-global-sellers">{{ $t('我在海外 · 卖中国好货') }}</router-link></li>
            <li><router-link to="/feature#buylink">{{ $t('BuyLink') }}</router-link></li>
            <li><router-link to="/for-china-sellers">{{ $t('代购与集运') }}</router-link></li>
            <li><router-link to="/cases">{{ $t('卖家案例') }}</router-link></li>
          </ul>
        </div>

        <div>
          <h5>{{ $t('资源') }}</h5>
          <ul>
            <li><router-link to="/question">{{ $t('帮助中心') }}</router-link></li>
            <li><router-link to="/question#start">{{ $t('开店教程') }}</router-link></li>
            <li><router-link to="/question#api">{{ $t('开放接口') }}</router-link></li>
            <li><router-link to="/question#status">{{ $t('服务状态') }}</router-link></li>
            <li><router-link to="/question#contact">{{ $t('联系我们') }}</router-link></li>
          </ul>
        </div>

        <div>
          <h5>{{ $t('公司') }}</h5>
          <ul>
            <li><router-link to="/about-us">{{ $t('关于 Taoify') }}</router-link></li>
            <li><router-link to="/about-us">{{ $t('加入我们') }}</router-link></li>
            <li><router-link to="/privacy-policy">{{ $t('隐私政策') }}</router-link></li>
            <li><router-link to="/terms-service">{{ $t('服务条款') }}</router-link></li>
            <li><router-link to="/consumer-agreement">{{ $t('退款政策') }}</router-link></li>
          </ul>
        </div>
      </div>

      <div class="footer__bottom">
        <span>© 2026 Taoify. {{ $t('保留所有权利。') }}</span>
        <span class="footer__langs">中文 · English · 日本語 · Deutsch · Français · Español · <em>{{ $t('等 20 种语言') }}</em></span>
      </div>
    </div>
  </footer>
</template>

<script>
import { openChat } from '@/utils/chat'

export default {
  name: 'WebsiteFooter',
  methods: {
    askAi () {
      openChat('')
    },
  },
}
</script>
